export default {"src":"/_next/static/media/carbon-neutral.02bbdaab.svg","height":1024,"width":1024};